import * as React from 'react';

export function Man() {
  return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="48"
      height="48"
      viewBox="10 5 48 48"
    >
      <defs>
        <circle id="b15" cx="24" cy="24" r="24"/>
        <filter id="a567" width="172.9%" height="172.9%" x="-36.5%" y="-26%" filterUnits="objectBoundingBox">
          <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0.419607843 0 0 0 0 0.768627451 0 0 0 0.15 0"/>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(10 5)">
          <use fill="#000" filter="url(#a)" xlinkHref="#b"/>
          <use fill="#FFF" xlinkHref="#b"/>
        </g>
        <path
          fill="#2B87DB"
          //tslint:disable-next-line:max-line-length
          d="M33.947 29.665c3.478 0 4.643-3.528 4.956-6.42.4-3.529-1.235-6.245-4.956-6.245s-5.356 2.681-4.956 6.244c.313 2.893 1.548 6.421 4.956 6.421zm9.999 8.82a20.668 20.668 0 0 0-.435-3.334 6.289 6.289 0 0 0-1.739-4.145c-.769-.42-1.587-.74-2.434-.953a11.166 11.166 0 0 1-1.044-.388 6.146 6.146 0 0 1-8.695 0c-.356.173-.722.326-1.095.459a10.34 10.34 0 0 0-2.382.882 6.288 6.288 0 0 0-1.74 4.075A20.653 20.653 0 0 0 24 38.344c0 .847.417.97 1.182 1.217.963.316 1.945.57 2.94.759 3.867.907 7.887.907 11.755 0a23.429 23.429 0 0 0 2.939-.759c.765-.247 1.217-.37 1.182-1.217l-.052.141z" opacity=".9"
        />
      </g>
    </svg>

  );
}
